import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=0486f9da&"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./InputPhoneNumber.vue?vue&type=style&index=0&id=0486f9da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports